import React from 'react';
import * as S from './styles';
import { Person } from '@material-ui/icons';
import PropTypes from 'prop-types';

const UserItem = ( { name, profileType, showProfileType = false } ) => {
	return (
		<S.UserItemContainer >
			<Person />
			<S.UserItemText>
				{name} {showProfileType && profileType && `- ${profileType}`}
			</S.UserItemText>
		</S.UserItemContainer>
	);
};

UserItem.propTypes = {
	name            : PropTypes.string.isRequired,
	profileType     : PropTypes.string,
	showProfileType : PropTypes.bool
};

export default UserItem;